import SDownload50 from "@/service/SDownload50.api.js";
import SDownload50Paotang from "@/service/SDownload50Paotang.api.js";

const state = {
};

const mutations = {
};

const getters = {
};

const actions = {
  async funcListSymbol({ dispatch, commit }) {
    //dispatch('loadingDialog/loading', true, { root: true });
    return await SDownload50.listAllSymbol()
      .then((res) => {
        //dispatch('loadingDialog/loading', false, { root: true });
        return res.data;
      })
      .catch((error) => {
        // dispatch('errorMessage/openModalErrorMessage', error, { root: true });
        // dispatch('loadingDialog/loading', false, { root: true });
        throw error;
      });
  },

  async funcPostGetIssuerDetail({ dispatch, commit }, req) {
    //dispatch('loadingDialog/loading', true, { root: true });
    return await SDownload50Paotang.PostGetIssuerDetail(req)
      .then((res) => {
        //dispatch('loadingDialog/loading', false, { root: true });
        return res.data;
      })
      .catch((error) => {
        //dispatch('errorMessage/openModalErrorMessage', error, { root: true });
        //dispatch('loadingDialog/loading', false, { root: true });
        throw error;
      });
  },

  async funcPostGetFileDownload({ dispatch, commit }, req) {
    //dispatch('loadingDialog/loading', true, { root: true });
    return await SDownload50Paotang.PostGetFileDownload(req)
      .then((res) => {
        //dispatch('loadingDialog/loading', false, { root: true });
        return res.data;
      })
      .catch((error) => {
        //dispatch('errorMessage/openModalErrorMessage', error, { root: true });
        //dispatch('loadingDialog/loading', false, { root: true });
        throw error;
      });
  },

  async funcGetListDownload({ dispatch, commit }) {
    //dispatch('loadingDialog/loading', true, { root: true });
    return await SDownload50.GetListDownload()
      .then((res) => {
        //dispatch('loadingDialog/loading', false, { root: true });
        return res.data;
      })
      .catch((error) => {
        // dispatch('errorMessage/openModalErrorMessage', error, { root: true });
        // dispatch('loadingDialog/loading', false, { root: true });
        throw error;
      });
  },

  funcPostDownloadForm({ dispatch, commit }, req) {
    //dispatch('loadingDialog/loading', true, { root: true });
    return SDownload50.PostDownloadForm(req)
      .then((res) => {
        //dispatch('loadingDialog/loading', false, { root: true });
        return res.data;
      })
      .catch((error) => {
        //dispatch('errorMessage/openModalErrorMessage', error, { root: true });
        //dispatch('loadingDialog/loading', false, { root: true });
        throw error;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
